export default __webpack_public_path__ + "static/media/ezzam-artworkinfo4.b7e8dc59.png";